/**
 * Labstep
 *
 * @module components/FilterPost/Report/ResourceLocation
 * @desc ResourceLocation filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type React from 'react';
import FilterPostReportResourceLocationForm from './Form';
import type { FilterPostReportResourceLocationProps } from './types';

const metadataNameCapitalised =
  ResourceLocation.getHumanReadableEntityName(false, true);

export const FilterPostReportResourceLocation: React.FC<
  FilterPostReportResourceLocationProps
> = ({ addPostFilter, path, protocolValueName, ...rest }) => (
  <Modal
    header={`Filter by ${metadataNameCapitalised}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
        dataCy="components/FilterPost/Report/ResourceLocation"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportResourceLocationForm
        addPostFilter={addPostFilter}
        onDone={toggleModal}
        path={path}
        protocolValueName={protocolValueName}
      />
    )}
    {...rest}
  />
);
